import Services from './Services';
import './Services.scss';

export default Services;
